import { CommonModule } from '@angular/common';
import { Component, contentChildren, effect, inject, Injector, input, OnInit, output, signal } from '@angular/core';

import { TabComponent } from './tab.component';

@Component({
  imports: [CommonModule],
  selector: 'ideals-tabs',
  styleUrls: ['./tabs.component.scss'],
  templateUrl: './tabs.component.html',
})
export class TabsComponent implements OnInit {
  readonly activeIndex = input<number>();

  readonly activeIndexChange = output<number>();

  readonly tabs = contentChildren(TabComponent);

  readonly #activeIndex = signal(0);
  readonly #injector = inject(Injector);

  ngOnInit(): void {
    this.#effects();
  }

  protected isActive(index: number): boolean {
    return this.#activeIndex() === index;
  }

  protected selectTab(index: number): void {
    this.#activeIndex.set(index);
    this.activeIndexChange.emit(index);
  }

  #effects(): void {
    effect(() => {
      this.#activeIndex.set(this.activeIndex() ?? 0);
    }, { injector: this.#injector });
  }
}
